<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M14.9231 4.76453L12.1106 1.95203C12.0583 1.89981 11.9962 1.8584 11.928 1.83017C11.8597 1.80194 11.7865 1.78744 11.7126 1.7875H6.0876C5.78923 1.7875 5.50308 1.90603 5.2921 2.117C5.08113 2.32798 4.9626 2.61413 4.9626 2.9125V4.0375H3.8376C3.53923 4.0375 3.25308 4.15603 3.0421 4.367C2.83113 4.57798 2.7126 4.86413 2.7126 5.1625V15.2875C2.7126 15.5859 2.83113 15.872 3.0421 16.083C3.25308 16.294 3.53923 16.4125 3.8376 16.4125H11.7126C12.011 16.4125 12.2971 16.294 12.5081 16.083C12.7191 15.872 12.8376 15.5859 12.8376 15.2875V14.1625H13.9626C14.261 14.1625 14.5471 14.044 14.7581 13.833C14.9691 13.622 15.0876 13.3359 15.0876 13.0375V5.1625C15.0877 5.08861 15.0732 5.01543 15.0449 4.94715C15.0167 4.87886 14.9753 4.81681 14.9231 4.76453ZM11.9938 15.2875C11.9938 15.3248 11.979 15.3606 11.9526 15.387C11.9262 15.4133 11.8905 15.4281 11.8532 15.4281H3.8376C3.8003 15.4281 3.76454 15.4133 3.73816 15.387C3.71179 15.3606 3.69698 15.3248 3.69698 15.2875V5.1625C3.69698 5.1252 3.71179 5.08944 3.73816 5.06306C3.76454 5.03669 3.8003 5.02188 3.8376 5.02188H4.9626V13.0375C4.9626 13.3359 5.08113 13.622 5.2921 13.833C5.50308 14.044 5.78923 14.1625 6.0876 14.1625H11.9938V15.2875ZM14.1438 13.0375C14.1438 13.0748 14.129 13.1106 14.1026 13.137C14.0762 13.1633 14.0405 13.1781 14.0032 13.1781H6.0876C6.0503 13.1781 6.01454 13.1633 5.98816 13.137C5.96179 13.1106 5.94698 13.0748 5.94698 13.0375V2.9125C5.94698 2.8752 5.96179 2.83944 5.98816 2.81306C6.01454 2.78669 6.0503 2.77188 6.0876 2.77188H11.4799L14.1438 5.43582V13.0375Z"
      fill="#D7DCE6"
    />
  </svg>
</template>

<script>
export default {
  name: 'FilesIconHollow18'
};
</script>

<style scoped>

</style>